import React, { lazy } from 'react';
const bonuses = [{
  title: 'Planificador de Temporada Completo',
  desc: 'Calendario visual de 12 meses + plantillas de planificación semanal.',
  image: 'https://cdn.magicpatterns.com/uploads/r1sao6aCM86gbcLPPHejQ8/Bono_futbol1.webp'
}, {
  title: 'Plantillas de Sesión en Blanco',
  desc: '30 hojas de sesión listas para completar con diagramas de campo incluidos.',
  image: 'https://cdn.magicpatterns.com/uploads/59G17A3Q5EwfoFfHDZHBKc/Futbol_bono_2.webp'
}, {
  title: 'Cuaderno Táctico',
  desc: '30 jugadas completas con diagramas para ofensa, defensa y balón parado.',
  image: 'https://cdn.magicpatterns.com/uploads/474DsxUj7g3ahRpTDJYtmg/Futbol_bono_3.webp'
}, {
  title: 'Sistema de Evaluación de Jugadores',
  desc: 'Kit completo con fichas por posición, gráficos de progreso e informes para padres.',
  image: 'https://cdn.magicpatterns.com/uploads/iW5ZyJ5KJDiweinJBznhhZ/Futbol_bono_4.webp'
}, {
  title: 'Biblia de Calentamientos',
  desc: '40 rutinas de calentamiento y vuelta a la calma organizadas por tiempo y objetivo.',
  image: 'https://cdn.magicpatterns.com/uploads/eUQ9EwSjFMgoLhRskdPXwW/Futbol_bono_5.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 Recibí también{' '}
            <span className="text-[#00A650]" data-id="element-5">5 Bonos Estratégicos</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium" data-id="element-6">
            Incluidos sin costo adicional
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-7">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#00A65033] rounded-2xl p-5 flex flex-col" data-id="element-8">
              <div className="relative mb-4 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-9">
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full h-44 object-cover" width={512} height={512} data-id="element-10" />
              </div>
              <div className="flex items-center justify-between mb-3" data-id="element-11">
                <span className="text-[#00A650] font-black text-sm tracking-wider uppercase" data-id="element-12">
                  Bono 0{i + 1}
                </span>
                <span className="bg-[#00A650]/10 text-[#00A650] text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-13">
                  Gratis
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-14">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-15">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}